import React from "react";
import { Document, Page } from "react-pdf";

class DocumentsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      files,
      filesInQueue,
      onDocumentDelete,
      viewPage,
      editable
    } = this.props;
    const docs = files.map(file => {
      const type = file.type;

      if (type.startsWith("image/")) {
        return (
          <DocumentImage
            editable={editable}
            key={file.id}
            file={file}
            viewPage={(url, page) => viewPage(url, page)}
            onDelete={() => onDocumentDelete(file.id)}
          />
        );
      } else if (type === "application/pdf") {
        return (
          <DocumentPdf
            editable={editable}
            key={file.id}
            file={file}
            viewPage={(url, page) => viewPage(url, page)}
            onDelete={() => onDocumentDelete(file.id)}
          />
        );
      } else {
        return (
          <p>
            Die Datei {file.name} kann nicht angezeigt werden. Sie hat einen
            ungültigen Datentyp.
          </p>
        );
      }
    });

    const queuePanel = (
      <div className="DocumentsPanelQueuePanel">
        <p>{`Es befinden sich ${filesInQueue} Datein in der Warteschlage`}</p>
      </div>
    );

    const empty = (
      <p
        style={{
          color: "var(--color-text-dark)",
          width: "100%",
          textAlign: "center",
          paddingTop: "120px",
          fontSize: 20
        }}
      >
        Lass uns anfangen!
        <br />
        Füge einfach Dokumente hinzu
        <h6>Unterstützte Formate: JPEG, PNG, WebP, TIFF, GIF und SVG</h6>
      </p>
    );

    return (
      <div className="DocumentsPanel">
        {filesInQueue > 0 ? queuePanel : null}
        {docs}
        {files.length <= 0 ? empty : null}
      </div>
    );
  }
}

class DocumentPdf extends React.Component {
  constructor(props) {
    super(props);
    this.state = { numPages: 0 };
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    const props = this.props;
    const { file, onDelete, viewPage, editable } = props;

    let pages = [];
    for (let i = 0; i < this.state.numPages; i++) {
      pages.push(
        <PageWrap
          key={i}
          pageNumber={i + 1}
          url={file.url}
          viewPage={viewPage}
        />
      );
    }

    return (
      <div className="DocumentsPanelDocument">
        <div id="Head">
          <p>{file.name}</p>
          <i id="Info" className="fas fa-info-circle" />
          <i
            id="Delete"
            className="fas fa-trash"
            onClick={() => onDelete()}
            style={editable ? { opacity: 1 } : { opacity: 0.5 }}
          />
        </div>
        <div className="DocumentsPanelPageWrapContainer">
          <Document
            className="DocumentsPanelPageWrap"
            file={file.url}
            onLoadSuccess={this.onDocumentLoad}
          >
            {pages}
          </Document>
        </div>
      </div>
    );

    function PageWrap(props) {
      return (
        <div className="DocumentsPanelPageWrap">
          <Page
            className="DocumentsPanelPage"
            pageNumber={props.pageNumber}
            renderAnnotations={false}
            renderTextLayer={false}
            onRenderSuccess={() => {}}
          >
            <i
              className="fas fa-expand"
              onClick={() => props.viewPage(props.url, props.pageNumber)}
            />
            <p>{props.pageNumber}</p>
          </Page>
        </div>
      );
    }
  }
}

function DocumentImage(props) {
  const { file, onDelete, viewPage, editable } = props;
  return (
    <div className="DocumentsPanelDocument">
      <div id="Head">
        <p>{file.name}</p>
        <i id="Info" className="fas fa-info-circle" />

        <i
          id="Delete"
          className="fas fa-trash"
          onClick={() => onDelete()}
          style={editable ? { opacity: 1 } : { opacity: 0.5 }}
        />
      </div>
      <div className="DocumentsPanelPageWrapContainer">
        <div className="DocumentsPanelPageWrap">
          <Page url={file.url} pageIndex={0} viewPage={viewPage} />
        </div>
      </div>
    </div>
  );

  function Page(props) {
    return (
      <div className="DocumentsPanelPage">
        <img src={props.url} />
        <i
          className="fas fa-expand"
          onClick={() => props.viewPage(props.url, props.pageIndex)}
        />
        <p>{props.pageIndex + 1}</p>
      </div>
    );
  }
}

export default DocumentsPanel;



// WEBPACK FOOTER //
// ./src/components/DocumentsPanel.js